export const categories = [
  {
    id: 1,
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=Single%20pair%20of%20premium%20white%20leather%20sneakers%20placed%20on%20natural%20linen%20fabric%20surface%20soft%20diffused%20morning%20sunlight%20from%20window%20casting%20gentle%20shadows%20clean%20minimalist%20product%20photography%20neutral%20cream%20beige%20color%20palette%20high%20end%20editorial%20style%20with%20generous%20negative%20space&width=400&height=400&seq=cat-shoes-001&orientation=squarish',
  },
  {
    id: 2,
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Oversized%20heather%20grey%20cotton%20hoodie%20neatly%20folded%20on%20smooth%20pale%20stone%20surface%20with%20warm%20ambient%20lighting%20from%20top%20right%20subtle%20texture%20details%20visible%20soft%20organic%20shadows%20minimalist%20aesthetic%20product%20photography%20neutral%20warm%20tones%20clean%20composition&width=400&height=400&seq=cat-hoodies-002&orientation=squarish',
  },
  {
    id: 3,
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Crisp%20white%20cotton%20crewneck%20tshirt%20perfectly%20folded%20on%20light%20oak%20wooden%20tabletop%20natural%20window%20light%20from%20left%20side%20subtle%20fabric%20weave%20texture%20visible%20clean%20modern%20product%20photography%20with%20soft%20blurred%20background%20minimalist%20style%20serene%20calm%20atmosphere&width=400&height=400&seq=cat-tshirts-003&orientation=squarish',
  },
  {
    id: 4,
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20olive%20green%20bomber%20jacket%20laid%20flat%20on%20smooth%20concrete%20surface%20with%20diffused%20natural%20daylight%20muted%20earthy%20tones%20subtle%20zipper%20and%20stitching%20details%20visible%20modern%20editorial%20product%20photography%20with%20clean%20lines%20and%20soft%20atmospheric%20shadows&width=400&height=400&seq=cat-jackets-004&orientation=squarish',
  },
  {
    id: 5,
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    image: 'https://readdy.ai/api/search-image?query=Well%20tailored%20beige%20chino%20pants%20neatly%20arranged%20on%20textured%20cream%20linen%20background%20gentle%20afternoon%20sunlight%20streaming%20through%20sheer%20curtain%20creating%20soft%20warm%20glow%20minimalist%20fashion%20product%20photography%20elegant%20relaxed%20composition%20with%20natural%20fabric%20drape&width=400&height=400&seq=cat-pants-005&orientation=squarish',
  },
  {
    id: 6,
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-customer-service-2-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20navy%20blue%20baseball%20cap%20with%20subtle%20embroidered%20logo%20placed%20on%20smooth%20light%20grey%20marble%20surface%20soft%20directional%20lighting%20from%20upper%20left%20clean%20modern%20product%20photography%20emphasizing%20fabric%20texture%20and%20curved%20brim%20silhouette%20elegant%20minimalist%20composition&width=400&height=400&seq=cat-headwear-006&orientation=squarish',
  },
  {
    id: 7,
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=Coordinated%20matching%20athleisure%20set%20of%20sage%20green%20hoodie%20and%20joggers%20neatly%20presented%20on%20warm%20beige%20textured%20surface%20diffused%20natural%20window%20light%20creating%20soft%20tones%20clean%20modern%20product%20photography%20with%20harmonious%20color%20palette%20relaxed%20editorial%20composition&width=400&height=400&seq=cat-sets-007&orientation=squarish',
  },
  {
    id: 8,
    name: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
    image: 'https://readdy.ai/api/search-image?query=Soft%20white%20cotton%20underwear%20neatly%20folded%20on%20pale%20blush%20pink%20linen%20fabric%20backdrop%20gentle%20diffused%20morning%20light%20creating%20delicate%20shadows%20clean%20minimalist%20product%20photography%20with%20focus%20on%20fabric%20softness%20and%20simple%20elegant%20presentation&width=400&height=400&seq=cat-underwear-008&orientation=squarish',
  },
  {
    id: 9,
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Professional%20athletic%20jersey%20in%20deep%20burgundy%20red%20with%20subtle%20mesh%20texture%20laid%20flat%20on%20smooth%20light%20grey%20surface%20studio%20lighting%20with%20soft%20highlights%20on%20fabric%20clean%20modern%20sports%20product%20photography%20minimalist%20composition%20emphasizing%20material%20quality%20and%20design%20details&width=400&height=400&seq=cat-jersey-009&orientation=squarish',
  },
  {
    id: 10,
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20wristwatch%20with%20leather%20strap%20and%20delicate%20gold%20necklace%20arranged%20artfully%20on%20smooth%20cream%20marble%20surface%20soft%20natural%20window%20light%20from%20right%20side%20sophisticated%20product%20photography%20warm%20neutral%20tones%20refined%20editorial%20composition%20with%20subtle%20reflections&width=400&height=400&seq=cat-accessories-010&orientation=squarish',
  },
  {
    id: 11,
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-handbag-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20tan%20leather%20tote%20bag%20standing%20upright%20on%20light%20oak%20wooden%20surface%20soft%20daylight%20from%20large%20window%20creating%20gentle%20highlights%20on%20leather%20grain%20modern%20minimalist%20product%20photography%20warm%20earthy%20tones%20clean%20sophisticated%20composition&width=400&height=400&seq=cat-bags-011&orientation=squarish',
  },
  {
    id: 12,
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    image: 'https://readdy.ai/api/search-image?query=Handcrafted%20dark%20brown%20leather%20belt%20elegantly%20coiled%20on%20smooth%20cream%20colored%20surface%20with%20soft%20directional%20lighting%20emphasizing%20grain%20texture%20and%20metal%20buckle%20detail%20minimalist%20product%20photography%20warm%20natural%20tones%20refined%20clean%20composition&width=400&height=400&seq=cat-belts-012&orientation=squarish',
  },
  {
    id: 13,
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20amber%20liquid%20on%20smooth%20white%20marble%20surface%20soft%20diffused%20backlight%20creating%20gentle%20glow%20and%20subtle%20reflections%20luxury%20product%20photography%20minimalist%20composition%20with%20warm%20golden%20tones%20sophisticated%20editorial%20style&width=400&height=400&seq=cat-perfumes-013&orientation=squarish',
  },
  {
    id: 14,
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    image: 'https://readdy.ai/api/search-image?query=Artfully%20arranged%20collection%20of%20small%20fashion%20essentials%20including%20sunglasses%20keychain%20and%20phone%20case%20on%20light%20beige%20linen%20surface%20soft%20natural%20window%20light%20clean%20modern%20lifestyle%20product%20photography%20harmonious%20neutral%20composition%20casual%20elegant%20aesthetic&width=400&height=400&seq=cat-other-014&orientation=squarish',
  },
];

export const featureCards = [
  {
    title: 'Basetao Spreadsheet',
    description: 'Templates, guides and tools to organize your shopping workflow.',
    icon: 'ri-file-excel-2-line',
    color: 'accent',
  },
  {
    title: 'Basetao Review',
    description: 'Honest platform analysis with real user experiences and feedback.',
    icon: 'ri-star-line',
    color: 'primary',
  },
  {
    title: 'Basetao Shipping Cost',
    description: 'Shipping methods comparison to find the cheapest and fastest options.',
    icon: 'ri-ship-line',
    color: 'accent',
  },
  {
    title: 'Basetao Coupon',
    description: 'Latest saving strategies, discount codes and promotion guides.',
    icon: 'ri-coupon-line',
    color: 'primary',
  },
  {
    title: 'Basetao Warehouse',
    description: 'Storage and QC guides to understand how warehouse processing works.',
    icon: 'ri-store-2-line',
    color: 'accent',
  },
  {
    title: 'Is Basetao Legit',
    description: 'Safety and trust analysis covering platform history and transparency.',
    icon: 'ri-shield-check-line',
    color: 'primary',
  },
];

export const comparisonData = [
  { aspect: 'Product Links', without: 'Lost product links', with: 'Organized database' },
  { aspect: 'Cost Tracking', without: 'Unknown costs', with: 'Shipping tracking' },
  { aspect: 'Price Comparison', without: 'Difficult comparison', with: 'Price comparison' },
  { aspect: 'Decision Speed', without: 'Manual searching', with: 'Faster decisions' },
  { aspect: 'Organization', without: 'Poor organization', with: 'Complete workflow' },
];

export const workflowSteps = [
  {
    step: 1,
    title: 'Find Products',
    description: 'Browse category pages to discover products that match your style and budget.',
    icon: 'ri-search-eye-line',
  },
  {
    step: 2,
    title: 'Compare Sellers',
    description: 'Use the spreadsheet to compare prices, quality, and seller ratings side by side.',
    icon: 'ri-scales-3-line',
  },
  {
    step: 3,
    title: 'Check Warehouse',
    description: 'Track when items arrive at the warehouse and review QC photos for quality.',
    icon: 'ri-building-2-line',
  },
  {
    step: 4,
    title: 'Calculate Shipping',
    description: 'Compare shipping methods, costs, and delivery times to choose the best option.',
    icon: 'ri-truck-line',
  },
];

export const faqItems = [
  {
    question: 'What is a Basetao Spreadsheet?',
    answer: 'A Basetao Spreadsheet is a structured resource system designed to help shoppers organize products, compare prices, track orders, and improve their buying workflow. Instead of searching through hundreds of links, you can access product information, reviews, shipping strategies, and shopping guides all in one organized place.',
  },
  {
    question: 'How do I use the Basetao Spreadsheet for ordering?',
    answer: 'Start by browsing product categories to find items you want. Add them to your spreadsheet with details like price, seller, size, and notes. When ready, use the links to visit the main Basetao Spreadsheet site to complete your purchase. The spreadsheet helps you stay organized throughout the entire process.',
  },
  {
    question: 'Is Basetao Spreadsheet free to use?',
    answer: 'Yes, all guides, templates, and resources on Basetao Sheet are completely free. We provide educational content and shopping tools to help you make better purchasing decisions. The main Basetao Spreadsheet shopping platform has its own pricing structure for their services.',
  },
  {
    question: 'Which shipping method is the cheapest for Basetao?',
    answer: 'Shipping costs vary depending on weight, destination, and shipping method. Generally, EUB offers the lowest rates for small packages, EMS provides a good balance of speed and cost, while DHL is the fastest but most expensive option. Our shipping guides provide detailed comparisons for different countries and package weights.',
  },
  {
    question: 'How long does Basetao warehouse storage last?',
    answer: 'Basetao typically offers free storage for a certain period, usually 30-90 days depending on their current policy. After that, storage fees may apply. It is best to check the latest warehouse policy on the official Basetao Spreadsheet platform, as terms can change over time.',
  },
  {
    question: 'Can I track my Basetao orders with the spreadsheet?',
    answer: 'Absolutely. The Basetao Spreadsheet includes order tracking templates where you can log order numbers, tracking IDs, shipping status, and estimated delivery dates. This gives you a centralized dashboard to monitor all your orders in one place.',
  },
];

export const trustBadges = [
  'Updated Guides',
  'Shipping Comparison',
  'Beginner Friendly',
  'Free Resources',
];

export const articleCards = [
  {
    slug: 'ultimate-basetao-spreadsheet-guide',
    title: 'The Ultimate Basetao Spreadsheet Guide 2026: Templates, Tips & Shopping Hacks',
    excerpt: 'A comprehensive guide to using Basetao Spreadsheet for organizing your shopping workflow. Learn about templates, shipping strategies, warehouse tips, and how to save money on every order.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20organized%20modern%20workspace%20desk%20with%20laptop%20displaying%20spreadsheet%20data%20next%20to%20a%20notebook%20and%20coffee%20cup%20soft%20natural%20light%20from%20window%20minimalist%20aesthetic%20warm%20neutral%20tones%20calm%20productive%20atmosphere%20editorial%20photography%20shallow%20depth%20of%20field&width=800&height=450&seq=article-guide-01&orientation=landscape',
    date: '2026-08-09',
    readTime: '15 min read',
    category: 'Spreadsheet Guide',
  },
  {
    slug: 'basetao-shipping-cost-guide',
    title: 'Basetao Shipping Cost Guide 2026: Complete Price Breakdown by Country & Weight',
    excerpt: 'Everything you need to know about Basetao shipping costs. Compare DHL, EMS, and EUB rates across different countries and package weights to find the cheapest method for your haul.',
    image: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20box%20with%20fragile%20tape%20on%20clean%20wooden%20desk%20next%20to%20a%20small%20globe%20and%20calculator%20soft%20natural%20window%20light%20warm%20tones%20modern%20minimalist%20product%20photography%20with%20global%20shipping%20theme%20clean%20organized%20composition&width=800&height=450&seq=article-shipping-02&orientation=landscape',
    date: '2026-08-08',
    readTime: '12 min read',
    category: 'Shipping',
  },
  {
    slug: 'basetao-review-2026',
    title: 'Basetao Review 2026: Honest Analysis, Pros & Cons, User Experience',
    excerpt: 'An unbiased Basetao review covering platform reliability, user experience, payment methods, shipping transparency, and real customer feedback. Learn what to expect before placing your first order.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20laptop%20screen%20displaying%20star%20rating%20review%20interface%20on%20clean%20white%20desk%20with%20a%20small%20plant%20and%20coffee%20cup%20soft%20natural%20daylight%20from%20window%20minimalist%20workspace%20aesthetic%20warm%20inviting%20tones%20calm%20professional%20atmosphere&width=800&height=450&seq=article-review-03&orientation=landscape',
    date: '2026-08-07',
    readTime: '10 min read',
    category: 'Review',
  },
  {
    slug: 'is-basetao-legit',
    title: 'Is Basetao Legit? Complete Safety & Trust Analysis Before Ordering',
    excerpt: 'Wondering if Basetao is safe to use? We analyze platform history, payment security, shipping reliability, and compare user reviews so you can shop with confidence.',
    image: 'https://readdy.ai/api/search-image?query=Shield%20icon%20symbol%20displayed%20on%20modern%20tablet%20screen%20resting%20on%20light%20marble%20desk%20surface%20with%20soft%20diffused%20window%20light%20creating%20calm%20atmosphere%20trust%20and%20security%20themed%20product%20photography%20warm%20neutral%20tones%20clean%20minimalist%20composition&width=800&height=450&seq=article-legit-04&orientation=landscape',
    date: '2026-08-06',
    readTime: '11 min read',
    category: 'Safety',
  },
  {
    slug: 'basetao-coupon-codes',
    title: 'Basetao Coupon Codes 2026: Latest Discounts, Promo Codes & Saving Tips',
    excerpt: 'Discover the latest Basetao coupon codes and discount strategies. Learn how to save on shipping, find seasonal promotions, and maximize every dollar on your next Basetao order.',
    image: 'https://readdy.ai/api/search-image?query=Stack%20of%20colorful%20discount%20coupon%20tags%20with%20scissors%20on%20smooth%20cream%20marble%20surface%20warm%20ambient%20lighting%20from%20window%20creating%20soft%20gentle%20shadows%20modern%20minimalist%20savings%20and%20shopping%20themed%20product%20photography%20clean%20inviting%20composition&width=800&height=450&seq=article-coupon-05&orientation=landscape',
    date: '2026-08-05',
    readTime: '9 min read',
    category: 'Savings',
  },
  {
    slug: 'basetao-warehouse-guide',
    title: 'Basetao Warehouse Guide: QC Photos, Storage Time & Processing Explained',
    excerpt: 'Understand how the Basetao warehouse works — from item arrival and QC photo checks to storage limits and consolidation. Maximize your warehouse experience to save on shipping.',
    image: 'https://readdy.ai/api/search-image?query=Organized%20storage%20shelving%20with%20neatly%20stacked%20brown%20cardboard%20boxes%20in%20bright%20clean%20warehouse%20interior%20soft%20industrial%20lighting%20from%20overhead%20clean%20modern%20logistics%20product%20photography%20warm%20neutral%20tones%20orderly%20professional%20atmosphere&width=800&height=450&seq=article-warehouse-06&orientation=landscape',
    date: '2026-08-04',
    readTime: '13 min read',
    category: 'Warehouse',
  },
  {
    slug: 'basetao-vs-superbuy',
    title: 'Basetao vs Superbuy 2026: Complete Comparison for International Shoppers',
    excerpt: 'Detailed side-by-side comparison of Basetao and Superbuy. We compare shipping costs, service fees, platform features, and user experience to help you choose the right shopping agent.',
    image: 'https://readdy.ai/api/search-image?query=Two%20smartphones%20placed%20side%20by%20side%20on%20clean%20white%20desk%20surface%20showing%20different%20shopping%20app%20interfaces%20split%20screen%20comparison%20concept%20soft%20natural%20window%20light%20warm%20tones%20modern%20technology%20product%20photography%20clean%20minimalist%20composition&width=800&height=450&seq=article-vs-07&orientation=landscape',
    date: '2026-08-03',
    readTime: '14 min read',
    category: 'Comparison',
  },
  {
    slug: 'basetao-spreadsheet-template',
    title: 'Basetao Spreadsheet Template: Free Excel & Google Sheets Downloads',
    excerpt: 'Download our free Basetao spreadsheet templates for Excel and Google Sheets. Includes product tracker, order log, shipping calculator, and haul planner templates ready to use.',
    image: 'https://readdy.ai/api/search-image?query=Open%20laptop%20displaying%20colorful%20spreadsheet%20template%20with%20organized%20data%20columns%20on%20clean%20bright%20desk%20soft%20window%20daylight%20mouse%20and%20notebook%20nearby%20modern%20productive%20workspace%20product%20photography%20warm%20neutral%20tones%20inviting%20organized%20composition&width=800&height=450&seq=article-template-08&orientation=landscape',
    date: '2026-08-02',
    readTime: '8 min read',
    category: 'Templates',
  },
  {
    slug: 'basetao-shipping-to-usa',
    title: 'Basetao Shipping to USA: Cost Calculator, Methods & Delivery Times 2026',
    excerpt: 'Complete guide to Basetao shipping to the United States. Compare DHL, EMS, EUB delivery times and costs for different package weights plus customs and import tax information.',
    image: 'https://readdy.ai/api/search-image?query=Small%20American%20flag%20placed%20beside%20a%20shipping%20box%20on%20clean%20light%20wood%20desk%20surface%20with%20calculator%20and%20notepad%20soft%20natural%20daylight%20from%20window%20warm%20patriotic%20yet%20modern%20product%20photography%20clean%20minimalist%20composition%20with%20neutral%20tones&width=800&height=450&seq=article-usa-09&orientation=landscape',
    date: '2026-08-01',
    readTime: '11 min read',
    category: 'Shipping',
  },
  {
    slug: 'basetao-beginners-guide',
    title: 'Basetao Beginners Guide 2026: How to Place Your First Order Step by Step',
    excerpt: 'New to Basetao? This step-by-step beginners guide walks you through account setup, product searching, ordering, warehouse processing, and international shipping for a smooth first experience.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20organized%20desk%20with%20open%20notebook%20showing%20handwritten%20numbered%20steps%20checklist%20a%20pen%20and%20a%20warm%20cup%20of%20coffee%20soft%20natural%20morning%20light%20from%20window%20calm%20inspiring%20beginner%20friendly%20atmosphere%20minimalist%20product%20photography%20warm%20inviting%20tones&width=800&height=450&seq=article-beginner-10&orientation=landscape',
    date: '2026-07-31',
    readTime: '10 min read',
    category: 'Beginners',
  },
];